import axios from 'axios';

const BASE_URL = 'https://dashboard.gestlifesurrogacy.com/api/articles';

export const getBlogArticles = async (page = 1, language = 'es') => {
  // Si hay JSON pre-generado en build/data, intentar cargarlo primero (cliente)
  if (typeof window !== 'undefined') {
    const safeFile = `articles_page_${page}_${language}.json`;
    try {
      const res = await fetch(`/data/${safeFile}`);
      if (res.ok) {
        const json = await res.json();
        return { data: json.data || json, ...json };
      }
    } catch (e) {
      console.warn('No se pudo leer JSON estático:', safeFile);
    }
  }
  
  // Si no hay JSON o estamos en build/server, usar API remota
  try {
    const response = await axios.get(`${BASE_URL}?page=${page}&language=${language}`);
    return response.data; // Retorna la respuesta completa
  } catch (error) {
    console.error('Error fetching blog articles', error);
    throw error;
  }
};

export const getArticleBySlug = async (slug, language = 'es') => {
  try {
    const normalizedSlug = slug.startsWith('/') ? slug.slice(1) : slug;
    const apiUrl = `${BASE_URL}/${normalizedSlug}?language=${language}`;
    const response = await axios.get(apiUrl);
    return response.data; // Retorna el artículo específico
  } catch (error) {
    console.error(`Error fetching article with slug ${slug}`, error);
    throw error;
  }
};
